<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .singlepage.pt-0.about-page
        .p-0
          .about-title
            h1.headline {{$tc('ui.about_us.headline')}}
            template(v-if="getLanguage == 'my'")
              p At EpicWin, we aim to become Asia’s leading one-stop platform for online gaming enthusiasts, offering a vast selection of games in sports betting, casinos, slots, and more. With over six years of experience in the online casino Malaysia market, our global team of experts works diligently to build a state-of-the-art gaming site using the latest technology. Our mission is to provide an extensive gaming selection in a hassle-free, enjoyable environment, making it easy for members to access their favourite games without complex procedures.
              p We’ve streamlined traditional casino processes, allowing faster access to games and simplified transactions. At EpicWin, our diverse team continuously innovates to deliver a lifelike gaming experience. Through thorough research and a deep understanding of customer needs, we consistently enhance our services. Our team is well-equipped with up-to-date industry insights, making EpicWin a true-to-life online casino experience, almost like stepping into a real casino. Join us to experience real-time gaming with our live dealers in the EpicWin Live Casino.
            template(v-else-if="getLanguage == 'zh'")
              p At EpicWin, we aim to become Asia’s leading one-stop platform for online gaming enthusiasts, offering a vast selection of games in sports betting, casinos, slots, and more. With over six years of experience in the online casino Malaysia market, our global team of experts works diligently to build a state-of-the-art gaming site using the latest technology. Our mission is to provide an extensive gaming selection in a hassle-free, enjoyable environment, making it easy for members to access their favourite games without complex procedures.
              p We’ve streamlined traditional casino processes, allowing faster access to games and simplified transactions. At EpicWin, our diverse team continuously innovates to deliver a lifelike gaming experience. Through thorough research and a deep understanding of customer needs, we consistently enhance our services. Our team is well-equipped with up-to-date industry insights, making EpicWin a true-to-life online casino experience, almost like stepping into a real casino. Join us to experience real-time gaming with our live dealers in the EpicWin Live Casino.
            template(v-else)
              p At EpicWin, we aim to become Asia’s leading one-stop platform for online gaming enthusiasts, offering a vast selection of games in sports betting, casinos, slots, and more. With over six years of experience in the online casino Malaysia market, our global team of experts works diligently to build a state-of-the-art gaming site using the latest technology. Our mission is to provide an extensive gaming selection in a hassle-free, enjoyable environment, making it easy for members to access their favourite games without complex procedures.
              p We’ve streamlined traditional casino processes, allowing faster access to games and simplified transactions. At EpicWin, our diverse team continuously innovates to deliver a lifelike gaming experience. Through thorough research and a deep understanding of customer needs, we consistently enhance our services. Our team is well-equipped with up-to-date industry insights, making EpicWin a true-to-life online casino experience, almost like stepping into a real casino. Join us to experience real-time gaming with our live dealers in the EpicWin Live Casino.
          .row.m-0
            .col-12.col-md-6.p-0
              .aboutus-info-box.aboutus-slide-left
                .d-flex
                  .flex-grow-1
                    .title {{$tc('ui.about_us.box_one.title')}}
                    .text {{$tc('ui.about_us.box_one.content_1')}}
                  .aboutus-icon
                    img.img-fluid(src="img/about_icon01.png")
            .col-12.col-md-6.p-0
              .aboutus-info-box.aboutus-slide-right
                .d-flex
                  .flex-grow-1
                    template(v-if="getLanguage == 'my'")
                      .title.mb-0 {{$tc('ui.about_us.box_two.title')}}
                      .title {{$tc('ui.about_us.box_two.title_1')}}
                      div {{$tc('ui.about_us.box_two.content_1')}}
                    template(v-else)
                      .title {{$tc('ui.about_us.box_two.title')}}
                      div {{$tc('ui.about_us.box_two.content_1')}}
                  .aboutus-icon
                    img.img-fluid(src="img/about_icon02.png")
          .row.m-0
            .col-6.col-md-4.p-0
              .aboutus-swiper-container
                .swiper-wrapper
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_one.title') }}
                    .d-flex.align-items-center.justify-content-center
                      .icon
                        img(src="img/about_icon_game.png")
                      .flex-grow-1
                        .highlight.d-block.d-lg-none {{ $tc('ui.about_us.swiperbox_one.mobile') }}
                        .highlight.d-none.d-lg-block {{ $tc('ui.about_us.swiperbox_one.highlight') }}
                        .text(:class="{'custom-font' : getLanguage == 'my'}") {{ $tc('ui.about_us.swiperbox_one.detail') }}
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_two.title') }}
                    img.img-fluid(src="img/movie_logo.png")
                    .text(:class="{'custom-font' : getLanguage == 'my'}") {{ $tc('ui.about_us.swiperbox_two.detail') }}
              .aboutus-swiper-container
                .swiper-wrapper
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_three.title') }}
                    .d-flex.align-items-center.justify-content-center
                      .icon
                        img(src="img/about_icon_member.png")
                      .flex-grow-1
                        template(v-if="getLanguage == 'zh'")
                          .highlight.d-block.d-lg-none {{ $tc('ui.about_us.swiperbox_three.mobile') }}
                          .text {{ $tc('ui.about_us.swiperbox_three.detail') }}
                          .highlight.d-none.d-lg-block {{ $tc('ui.about_us.swiperbox_three.highlight') }}
                        template(v-else)
                          .highlight.d-block.d-lg-none {{ $tc('ui.about_us.swiperbox_three.mobile') }}
                          .highlight.d-none.d-lg-block {{ $tc('ui.about_us.swiperbox_three.highlight') }}
                          .text {{ $tc('ui.about_us.swiperbox_three.detail') }}
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_four.title') }}
                    .d-flex.align-items-center.justify-content-center
                      .icon
                        img(src="img/about_icon_turnover.png")
                      .flex-grow-1
                        template(v-if="getLanguage == 'zh'")
                          .highlight.d-block.d-lg-none {{ $tc('ui.about_us.swiperbox_four.mobile') }}
                          .text {{ $tc('ui.about_us.swiperbox_four.detail') }}
                          .highlight {{ $tc('ui.about_us.swiperbox_four.highlight') }}
                        template(v-else)
                          .highlight.d-block.d-lg-none {{ $tc('ui.about_us.swiperbox_four.mobile') }}
                          .highlight.d-none.d-lg-block {{ $tc('ui.about_us.swiperbox_four.highlight') }}
                          .text {{ $tc('ui.about_us.swiperbox_four.detail') }}
            .col-4.p-0.official-logo.d-none.d-md-flex.justify-content-center.align-item-center
              img(src="img/epic_official_logo.png")
            .col-6.col-md-4.p-0
              .aboutus-swiper-container
                .swiper-wrapper
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_five.title') }}
                    .d-flex.align-items-center.justify-content-center
                      .icon
                        img(src="img/about_icon_gift.png")
                      .flex-grow-1
                        .highlight.d-block.d-lg-none {{ $tc('ui.about_us.swiperbox_five.mobile') }}
                        .text {{ $tc('ui.about_us.swiperbox_five.detail') }}
                        .highlight.d-none.d-lg-block {{ $tc('ui.about_us.swiperbox_five.highlight') }}
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_six.title') }}
                    .epic-media.d-none.d-md-block
                      img(src="img/about_icon_epic.png")
                    .epic-media.d-md-none
                      img(src="img/about_icon_epic_mobile.png")
                    .text {{ $tc('ui.about_us.swiperbox_six.detail') }}
              .aboutus-swiper-container
                .swiper-wrapper
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_seven.title') }}
                    .d-flex.align-items-center.justify-content-center
                      .icon
                        img(src="img/about_icon_milestone.png")
                      .flex-grow-1
                        .highlight {{ $tc('ui.about_us.swiperbox_seven.highlight') }}
                        .text {{ $tc('ui.about_us.swiperbox_seven.detail') }}
                  .swiper-slide.aboutus-info-box.small-box
                    .title.grn {{ $tc('ui.about_us.swiperbox_eight.title') }}
                    .d-flex.align-items-center.justify-content-center
                      .icon
                        img(src="img/about_icon_community.png")
                      .flex-grow-1
                        .text {{ $tc('ui.about_us.swiperbox_eight.detail') }}
          .row.m-0
            .col-12.col-md-6.p-0
              .aboutus-info-box.aboutus-slide-left
                .d-flex
                  .flex-grow-1
                    .title {{$tc('ui.about_us.box_three.title')}}
                    div {{$tc('ui.about_us.box_three.content_1')}} 
                  .aboutus-icon
                    img.img-fluid(src="img/about_icon03.png")
            .col-12.col-md-6.p-0
              .aboutus-info-box.aboutus-slide-right
                .d-flex
                  .flex-grow-1
                    .title {{$tc('ui.about_us.box_four.title')}}
                    div {{$tc('ui.about_us.box_four.content_1')}} 
                  .aboutus-icon
                    img.img-fluid(src="img/about_icon04.png")
</template>

<script>
export default {
  // metaInfo: {
  //   title: 'About Epicwin - Trusted Online Casino in Malaysia |  Download epicwin app',
  // },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed : {
    getLanguage() {
      return this.$store.getters.language || "en"
    }
  },
  mounted() {
    window.scroll(0,0)
    this.$helpers.swiper();
    // this.getSeo()
    // $(".subpage-slider .slider").slick({
    //   arrows: false,
    //   dots: false,
    //   infinite: false,
    //   slidesToShow: 2
    // });
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
  }
}
</script>
<style lang="scss" scoped>
// @import "../../../public/css/swiper.min.css";
// .custom-font{
//   font-size: 12px
// }
</style>